import { useRef } from "react";
import styles from "./styles";
import { HeaderSearch } from "../../components/HeaderSearch";
import { VeryTable } from "../../components/common/v2/VeryTable";
import classVeryTable from "../../components/common/v2/VeryTable/classVeryTable";
import { classVeryIconGoogle } from "../../components/common/v2/VeryIconGoogle/classVeryIconGoogle";
import { VeryBtnFill } from "../../components/common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../components/common/v2/VeryBtnFill/classVeryBtnFill";
import { classVeryBtnOutlined } from "../../components/common/v2/VeryBtnOutlined/classVeryBtnOutlined";
import { VeryBtnOutlined } from "../../components/common/v2/VeryBtnOutlined";
import {
  getFormattedFullName,
  getFormattedNumber,
} from "../../utils/handler_validations";
import { getDateFull_S1, momentES } from "../../utils/handler_dates";
import { useCancellationsContext } from "../../context";
import { CellTooltip } from "../../components/common/v2/VeryTable/CellTooltip";
import StylesCellTooltip from "../../components/common/v2/VeryTable/CellTooltip/styles";
import { CancellationDetailPanel } from "../../components/cancellations/CancellationDetailPanel";
import { ModalBlockDriver } from "../../components/cancellations/ModalBlockDriver";
import { ModalCompensatePassenger } from "../../components/cancellations/ModalCompensatePassenger";

const FILTER_OPTIONS = [
  { value: "", label: "Todas" },
  { value: "1", label: "Por pasajero" },
  { value: "2", label: "Por conductor" },
];

const ContentCancellationsPage = () => {
  const cancellations = useCancellationsContext();
  const refDivMain = useRef();

  return (
    <>
      <styles.DivMain
        reff={refDivMain}
        isLoading={cancellations.page.loading}
        error={cancellations.page.error}
        onClickBtnRetry={() => cancellations.getListInitial()}
      >
        {/* HEADER */}
        <HeaderSearch
          inputSearch={{
            placeHolder: "Buscar por nombre o motivo",
            text: cancellations.filterSearch,
            onChangeText: (v) => cancellations.onChangeFilterSearch(v),
            onClick: () => cancellations.getListFiltered(),
          }}
        >
          <VeryBtnFill
            CSS={["btnReload"]}
            colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
            icon={{
              name: "refresh",
              size: 18,
              type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
            }}
            onClick={() => cancellations.getListInitial()}
          />
        </HeaderSearch>

        {/* FILTROS */}
        <div className="div-filterRow">
          {FILTER_OPTIONS.map(({ value, label }) => (
            <button
              key={value}
              className={`btn-filter${cancellations.filterCanceledBy === value ? " active" : ""}`}
              onClick={() => {
                cancellations.onChangeFilterCanceledBy(value);
                cancellations.getListFiltered(value);
              }}
            >
              {label}
            </button>
          ))}
          <span
            style={{
              marginLeft: "auto",
              fontSize: 12,
              color: "#aaa",
              fontFamily: "Roboto",
            }}
          >
            {getFormattedNumber(cancellations.total, true, 0)} cancelaciones
          </span>
        </div>

        {/* TABLE */}
        <VeryTable
          CSS={["cancellationsTable"]}
          rows={cancellations.list ?? []}
          getRowId={(row) => row.serviceId}
          disabledRowSelection={false}
          rowSelected={
            cancellations.selectedServiceId > 0
              ? cancellations.selectedServiceId
              : -1
          }
          onChangeRowSelected={(id) => {
            if (id && id > 0) cancellations.loadDetail(id);
            else cancellations.closeDetail();
          }}
          columns={{
            col_passenger: classVeryTable.getColumnTemplate(
              "Pasajero",
              "Nombre del pasajero",
              1,
              180,
              130,
              true,
              true,
              (params) =>
                getFormattedFullName(
                  params.row.passengerName,
                  params.row.passengerLastName,
                ),
              (params) =>
                classVeryTable.renderColProfile(
                  params.row.passengerProfileImg,
                  params.value,
                ),
            ),
            col_driver: classVeryTable.getColumnTemplate(
              "Conductor",
              "Nombre del conductor",
              1,
              180,
              130,
              true,
              true,
              (params) =>
                params.row.driverId
                  ? getFormattedFullName(
                      params.row.driverName,
                      params.row.driverLastName,
                    )
                  : "—",
              (params) =>
                params.row.driverId ? (
                  classVeryTable.renderColProfile(
                    params.row.driverProfileImg,
                    params.value,
                  )
                ) : (
                  <CellTooltip
                    contentCell={
                      <StylesCellTooltip.LabelCell>
                        {params.value}
                      </StylesCellTooltip.LabelCell>
                    }
                  />
                ),
            ),
            col_canceledBy: classVeryTable.getColumnTemplate(
              "Cancelado por",
              "Quién canceló el viaje",
              0,
              140,
              110,
              true,
              true,
              (params) =>
                params.row.canceledBy === 2 ? "Conductor" : "Pasajero",
              (params) => (
                <span
                  className={
                    params.row.canceledBy === 2 ? "tag-driver" : "tag-passenger"
                  }
                >
                  {params.value}
                </span>
              ),
            ),
            col_motive: classVeryTable.getColumnTemplate(
              "Motivo",
              "Motivo de cancelación",
              2,
              300,
              120,
              false,
              true,
              (params) => params.row.motive || "Sin motivo",
              (params) => (
                <CellTooltip
                  contentCell={
                    <StylesCellTooltip.LabelCell>
                      {params.value}
                    </StylesCellTooltip.LabelCell>
                  }
                />
              ),
            ),
            col_date: classVeryTable.getColumnTemplate(
              "Fecha",
              "Fecha de cancelación",
              0,
              200,
              150,
              true,
              true,
              (params) =>
                params.row.canceledDate
                  ? new Date(params.row.canceledDate).getTime()
                  : 0,
              (params) => {
                const txt = params.row.canceledDate
                  ? getDateFull_S1(momentES(params.row.canceledDate))
                  : "—";
                return (
                  <CellTooltip
                    contentCell={
                      <StylesCellTooltip.LabelCell>
                        {txt}
                      </StylesCellTooltip.LabelCell>
                    }
                  />
                );
              },
            ),
            col_cost: classVeryTable.getColumnTemplate(
              "Costo",
              "Costo del viaje",
              0,
              100,
              80,
              true,
              true,
              (params) => params.row.cost,
              (params) => classVeryTable.renderColMoney(params.value),
            ),
            col_status: classVeryTable.getColumnTemplate(
              "Estado",
              "Estatus del caso",
              0,
              140,
              100,
              false,
              true,
              (params) => {
                const s = params.row.status;
                if (s === "COMPLETED") return 2;
                if (s === "IN_PROGRESS") return 1;
                return 0;
              },
              (params) => {
                const s = params.row.status;
                if (s === "COMPLETED")
                  return (
                    <span className="tag-status tag-both">Completado</span>
                  );
                if (s === "IN_PROGRESS")
                  return (
                    <span className="tag-status tag-compensated">
                      En proceso
                    </span>
                  );
                return (
                  <span className="tag-status tag-pending">Pendiente</span>
                );
              },
            ),
          }}
        />

        {/* LOAD MORE */}
        {cancellations.hasMore && (
          <div className="div-loadMore">
            <VeryBtnOutlined
              CSS={["btn-loadMore"]}
              label={cancellations.loadingMore ? "Cargando..." : "Cargar más"}
              isLoading={cancellations.loadingMore}
              colorTheme={classVeryBtnOutlined.COLOR_THEME.BLACK_S1}
              onClick={() => cancellations.loadMore()}
            />
          </div>
        )}
      </styles.DivMain>

      {/* PANEL DETALLE */}
      <CancellationDetailPanel refSlide={refDivMain} />

      {/* MODALES */}
      <ModalBlockDriver />
      <ModalCompensatePassenger />
    </>
  );
};

export default ContentCancellationsPage;
